// Helpers partages du module Recouvrement.

export const formatNumber = (value) => new Intl.NumberFormat('fr-FR').format(Number(value || 0));

export const formatMontant = (value) => `${formatNumber(Math.round(Number(value || 0)))} FCFA`;

// Taux de recouvrement = part deja encaissee sur le montant attendu.
export const getTauxRecouvrement = (montantPaye, montantAttendu) => {
  const attendu = Number(montantAttendu || 0);
  if (attendu <= 0) return 0;
  return Math.max(0, Math.min(100, Math.round((Number(montantPaye || 0) / attendu) * 100)));
};

export const matchRecherche = (eleve, terme) => {
  const value = String(terme || '').trim().toLowerCase();
  if (!value) return true;
  return [
    eleve.nom,
    eleve.prenom,
    eleve.matricule,
    eleve.classe_nom,
    eleve.section_nom,
    eleve.parent_nom,
    eleve.parent_telephone
  ].some((field) => String(field || '').toLowerCase().includes(value));
};
